import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import CustomerHeader from "@/components/CustomerHeader";
import { Sparkles } from "lucide-react";

export default function History() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/fortunes").then(({ data }) => setItems(data));
  }, []);

  return (
    <div className="cosmic-bg min-h-screen">
      <div className="stars" />
      <CustomerHeader />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        <h1 className="font-serif-myst text-4xl mb-6">Fal Geçmişim</h1>
        {items.length === 0 ? (
          <div className="glass rounded-2xl p-8 text-center text-white/60" data-testid="history-empty">
            Henüz bir falın yok. <Link to="/panel" className="gold-text hover:underline">Panele dön</Link>
          </div>
        ) : (
          <div className="space-y-3" data-testid="history-list">
            {items.map((f) => (
              <Link key={f.id} to={`/sonuc/${f.id}`} data-testid={`history-item-${f.id}`} className="glass rounded-2xl p-4 flex items-center justify-between hover:border-[#D4AF37]/40 border border-white/5 transition-colors">
                <div className="flex items-center gap-3 min-w-0">
                  <Sparkles className="w-5 h-5 gold-text shrink-0" />
                  <div className="min-w-0">
                    <div className="font-serif-myst text-xl capitalize">{f.fortune_type_slug}</div>
                    <div className="text-xs text-white/50 truncate">{(f.result_text || "").slice(0, 100)}...</div>
                  </div>
                </div>
                <div className="text-xs text-white/40 whitespace-nowrap ml-3">{new Date(f.created_at).toLocaleDateString("tr-TR")}</div>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
